
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensesDisplayGridRowDataFragment, LensSortOrder, WorkbookUpstreamLensesQuery, WorkbookUpstreamLensesQueryVariables , WorkbookUpstreamLensesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import {
  LensesDisplayGrid,
  LensesDisplayGridRowData,
  getRowDataForLens,
} from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = WorkbookUpstreamLensesQueryVariables;
type QueryResults = WorkbookUpstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;


function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.workbooks && resultData.workbooks[0] && resultData.workbooks[0]?.upstreamLensesConnection;
}

export type WorkbookUpstreamLensesQueryGridProps =
  GridSortProps<LensesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export function WorkbookUpstreamLensesQueryGrid(props: WorkbookUpstreamLensesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamLensesLineageGridMessage();

  return <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={WorkbookUpstreamLensesDocument}
    partialQueryVariables={{ workbookVizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as LensSortOrder }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={getRowDataForLens}
  >
    {({ rowStore }) =>
      <LensesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />
    }
  </PaginatedQueryWrapper>;
}
